// Behavior enum values
export enum behaviorMap{
    UNDEFINED =  0, // default, Undefined
  
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Page Experience [1-19]
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    NAVIGATIONBACK =  1, // Advancing to the previous index position within a webpage
    NAVIGATION =  2, // Advancing to a specific index position within a webpage
    NAVIGATIONFORWARD =  3, // Advancing to the next index position within a webpage
    APPLY =  4, // Applying filter(s) or making selections
    REMOVE =  5, // Applying filter(s) or removing selections
    SORT =  6, // Sorting content
    EXPAND =  7, // Expanding content or content container
    REDUCE =  8, // Sorting content
    CONTEXTMENU =  9, // Context Menu
    TAB =  10, // Tab control
    COPY =  11, // Copy the contents of a page
    PRINT =  13, // User printed page
    SHOW =  14, //  Displaying an overlay
    HIDE =  15, //  Hiding an overlay
    MAXIMIZE =  16, //  Maximizing an overlay
    MINIMIZE =  17, // Minimizing an overlay
    BACKBUTTON =  18, //  Clicking the back button
  
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Scenario Process [20-39]
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    STARTPROCESS =  20, // Initiate a web process unique to adopter
    PROCESSCHECKPOINT =  21, // Represents a checkpoint in a web process unique to adopter
    COMPLETEPROCESS =  22, // Page Actions that complete a web process unique to adopter
    SCENARIOCANCEL =  23, // Actions resulting from cancelling a process/scenario
  
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Download [40-59]
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    DOWNLOADCOMMIT =  40, // Initiating an unmeasurable off-network download
    DOWNLOAD =  41, // Initiating a download
  
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Search [60-79]
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    SEARCHAUTOCOMPLETE =  60, // Auto-completing a search query during user input
    SEARCH =  61, // Submitting a search query
    SEARCHINITIATE =  62, // Initiating a search query
    TEXTBOXINPUT =  63, // Typing or entering text in the text box
  
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Authentication [100-119]
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    SIGNIN =  100, // User sign-in
    SIGNOUT =  101, // User sign-out
  
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Feedback [140-159]
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    VOTE =  140, // Rating content or voting for content
    SURVEYCHECKPOINT =  145, // reaching the survey page/form
  
      ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Signup [210-219]
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    SIGNUP =  210, // Signing-up for a notification or service
    FREESIGNUP =  211, // Signing-up for a free service
  
      OTHER =  300 // Other
  };